import {AbstractControl, FormGroup, ValidatorFn} from '@angular/forms';
import {DocumentErrorCode} from './document-error-codes';

export class DocumentValidators {
  private static readonly MAX_SIZE_IN_MB = 100;
  private static readonly TOTAL_MAX_SIZE_IN_MB = 500;

  /**
   * Checks if file is not bigger than provided value.
   */
  static fileSizeValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const file = control.value && control.value.files && control.value.files[0];
      return !file || file.size <= this.MAX_SIZE_IN_MB * 1024 * 1024 ? null : {[DocumentErrorCode.maxFileSize]: this.MAX_SIZE_IN_MB};
    };
  }

  /**
   * Checks if total file size is bigger than provided size.
   */
  static totalFilesSizeValidator(currentTotalSizeInBytes: number, isEdit: boolean): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const file = control.value && control.value.files && control.value.files[0];
      const fileSizeInBytes = (isEdit && file ? 0 : file?.size) ?? 0;

      return currentTotalSizeInBytes + fileSizeInBytes <= this.TOTAL_MAX_SIZE_IN_MB * 1024 * 1024
        ? null
        : {[DocumentErrorCode.totalMaxFilesSize]: this.TOTAL_MAX_SIZE_IN_MB};
    };
  }

  /**
   * Checks if name is unique.
   */
  static uniqueNameValidator(names: Array<string>): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const name = control.value?.toLowerCase();

      return names.includes(name) ? {[DocumentErrorCode.uniqueName]: null} : null;
    };
  }
}
